module.exports = __webpack_public_path__ + "static/media/no_appraisal.819b5af3.png";